import * as React from 'react';

import './Loader.scss';

class Loader extends React.Component<Loader.IProps, Loader.IState> {
  static defaultProps = { fixed: true };
  renderBalls = () => {
    return [0, 1, 2].map(value => <div key={value + 1} className={`bounce-${value + 1}`} /> || '');
  };

  render() {
    const { loading, loadingMessage } = this.props;

    if (!loading) {
      return null;
    }

    return (
      <div
        className={`d-flex flex-column loader text-center ${this.props.fixed ? 'fixed-loader' : ''} ${this.props.className || ''}`}>
        <div className={`mx-auto mt-auto spinner ${!loadingMessage ? 'mb-auto' : ''}`}>{this.renderBalls()}</div>
        {loadingMessage ? <p className="mx-auto eon-title eon-white mb-auto">{loadingMessage}</p> : ''}
      </div>
    );
  }
}


export default Loader;
